var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 230,
    viewBox: "0 0 298 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298 183.245C298 208.746 277.235 229.511 251.734 229.511H0V46.2665C0 20.7653 20.7653 0 46.2665 0H298V183.245Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.032 136.249H235.158C235.704 136.249 236.979 136.067 237.526 136.067C241.169 135.339 244.265 132.06 244.265 127.506C244.265 123.134 241.169 119.856 237.526 118.945C236.979 118.763 235.886 118.763 235.158 118.763H216.032V136.249Z",
    fill: "url(#paint0_linear_1_17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.972 15.4829C214.757 15.4829 199.82 30.2372 199.82 48.6345V83.0611H246.633C247.726 83.0611 249.001 83.0611 249.912 83.2433C260.477 83.7897 268.309 89.2543 268.309 98.7262C268.309 106.194 263.027 112.57 253.191 113.845V114.209C263.938 114.938 272.134 120.949 272.134 130.238C272.134 140.257 263.027 146.814 251.005 146.814H199.638V214.21H248.273C266.488 214.21 281.424 199.456 281.424 181.059V15.4829H232.972Z",
    fill: "url(#paint1_linear_1_17)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.897 100.912C241.897 96.5403 238.801 93.6259 235.158 93.0795C234.793 93.0795 233.883 92.8973 233.336 92.8973H216.032V108.927H233.336C233.883 108.927 234.976 108.927 235.158 108.744C238.801 108.198 241.897 105.284 241.897 100.912Z",
    fill: "url(#paint2_linear_1_17)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7274 15.4829C31.5122 15.4829 16.5758 30.2372 16.5758 48.6345V130.421C25.8655 134.974 35.5196 137.889 45.1736 137.889C56.6491 137.889 62.8423 130.967 62.8423 121.495V82.879H91.2579V121.313C91.2579 136.249 81.9682 148.454 50.456 148.454C31.3301 148.454 16.3936 144.264 16.3936 144.264V214.028H65.0281C83.2433 214.028 98.1797 199.274 98.1797 180.877V15.4829H49.7274Z",
    fill: "url(#paint3_linear_1_17)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.35 15.4829C123.134 15.4829 108.198 30.2372 108.198 48.6345V91.9866C116.577 84.8826 131.149 80.3289 154.647 81.4218C167.215 81.9682 180.694 85.4291 180.694 85.4291V99.4548C173.955 95.9939 165.94 92.8973 155.557 92.1687C137.707 90.8936 126.96 99.6369 126.96 114.938C126.96 130.421 137.707 139.164 155.557 137.707C165.94 136.978 173.955 133.699 180.694 130.421V144.446C180.694 144.446 167.397 147.907 154.647 148.454C131.149 149.546 116.577 144.993 108.198 137.889V214.392H156.833C175.048 214.392 189.984 199.638 189.984 181.241V15.4829H141.35Z",
    fill: "url(#paint4_linear_1_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_17",
    x1: 199.79,
    y1: 127.528,
    x2: 281.644,
    y2: 127.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_17",
    x1: 199.787,
    y1: 114.767,
    x2: 281.648,
    y2: 114.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_17",
    x1: 199.788,
    y1: 100.889,
    x2: 281.645,
    y2: 100.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_17",
    x1: 16.5372,
    y1: 114.767,
    x2: 99.6585,
    y2: 114.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_17",
    x1: 107.727,
    y1: 114.767,
    x2: 188.457,
    y2: 114.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.00573d85341179a0b20ef33429ec1333.svg";
export { ForwardRef as ReactComponent };